import { z } from 'zod';

/**
 * Zod schema for the PUT /suppliers/priority request JSON body (PriorityListUpdate).
 */
export const zodPutSuppliersPriorityPayloadSchema = z.object({
  highPriority: z.array(z.uuid()),
  recipientCompanyIds: z.array(z.uuid()).min(1),
  regularPriority: z.array(z.uuid()),
});
